export default __webpack_public_path__ + "static/media/room2-MASK-tile.50181d39.png";